var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnivention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 40.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 364 c-23 -22 -20 -34 9 -34 25 0 25 0 25 -94 0 -104 1 -106 69 -106 54 0 61 13 61 107 0 84 6 96 34 67 12 -12 16 -38 16 -115 0 -99 0 -99 -25 -99 -14 0 -25 5 -25 10 0 7 -6 7 -19 0 -22 -11 -120 -13 -137 -2 -24 16 -34 55 -34 136 0 87 -6 99 -34 70 -13 -12 -16 -39 -16 -129 0 -147 1 -148 155 -143 93 3 108 6 120 23 18 25 25 32 50 50 17 12 20 27 23 120 5 154 4 155 -143 155 -90 0 -117 -3 -129 -16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnivention);
export default __webpack_public_path__ + "static/media/univention.d6ccfeb7657d98a1a0c07239ca510c98.svg";
export { ForwardRef as ReactComponent };